import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { counterTime } from '@configs/questions.config';
import { AssessmentService } from '@services/assessment.service';
import { Subscription, timer } from 'rxjs';
import { WebErrorService } from '@services/webError.service';
import { NotificationService } from '@services/notification.service';
import { scheduleCodeEnum, assessmentTypeId } from '@configs/assessment.config';

@Component({
  selector: 'app-confirm-otp',
  templateUrl: './confirm-otp.component.html',
  styleUrls: ['./confirm-otp.component.scss']
})
export class ConfirmOtpComponent implements OnInit {
  confirmOTPForm: FormGroup;
  counter = counterTime.counter;
  isEnable: boolean = true;
  isTimeShow: boolean = false;
  minutes: number;
  seconds: any;
  collectionId: any;
  errorMessage: any;
  timeLeft: Date = new Date(this.counter * 1000); // Convert to Date object for formatting
  private intervalId: any;
  private startTime: number = 0;
  constructor(public dialogRef: MatDialogRef<ConfirmOtpComponent>,
    public assessmentSrc: AssessmentService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private webErrorService: WebErrorService,
    private notificationService: NotificationService,
    private cd: ChangeDetectorRef) {
    this.confirmOTPForm = new FormGroup({
      confirmOtp: new FormControl('', [Validators.required])
    })
  }

  ngOnInit(): void {
    this.collectionId = JSON.parse(sessionStorage.getItem('defaultcollectionid'));
    this.startTimer();
    // this.countDownFun();
  }

  get f() {
    return this.confirmOTPForm.controls;
  }

  startTimer() {
    this.startTime = Date.now();
    this.intervalId = setInterval(() => {
      const elapsed = Math.floor((Date.now() - this.startTime) / 1000);
      const remaining = this.counter - elapsed;

      if (remaining <= 0) {
        this.isEnable = false;
        clearInterval(this.intervalId);
        this.timeLeft = new Date(0); // Reset to 0
      } else {
        this.isTimeShow = true;
        this.timeLeft = new Date(remaining * 1000);
        this.minutes = Math.floor(remaining / 60);
        this.seconds = this.timeLeft.getSeconds();
      }
    }, 1000);
  }

  // countDownFun() {  ///// old timer code
  //   setInterval(() => {
  //     if (this.counter > 0) {
  //       --this.counter
  //       this.isTimeShow = true;
  //       this.minutes = Math.floor(this.counter / 60);
  //       this.seconds = ('00' + Math.floor(this.counter - this.minutes * 60)).slice(-2)
  //       this.cd.detectChanges();
  //       if (this.counter === 0) {
  //         this.isEnable = false;
  //         // this.countDown.unsubscribe();
  //       }
  //     }
  //   }, 1000)

  //   // this.countDown = timer(0, 1000).subscribe(() => {
  //   // });
  // }

  ngOnDestroy() {
    clearInterval(this.intervalId);
  }

  onKeydown(event: KeyboardEvent) {
    this.errorMessage = '';
    if (event.key === ' ' && !this.confirmOTPForm.value.confirmOtp.length)
      event.preventDefault();
  }

  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)

    return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 ||(k >= 48 && k <= 57) || k == 46);
  }

  closeDialog() {
    this.dialogRef.close();
    this.counter = 0
    clearInterval(this.intervalId);
  }

  onSubmit() {
    if (this.confirmOTPForm.valid) {
      this.assessmentSrc.verifyOtp(this.data.patientuuid, this.confirmOTPForm.value.confirmOtp).subscribe(data => {
        if (data.success) {
          this.notificationService.success(data.message);
          let assessmentStatusId = this.data.assessmentStatusId == undefined ? 1 : this.data.assessmentStatusId;
          this.assessmentSrc.sendAssessmentUrl(this.data.patientid, '', assessmentStatusId, assessmentTypeId.patientAssisted, scheduleCodeEnum.A1, this.collectionId).subscribe((res) => {
            this.dialogRef.close(data.success);
          }, (error: any) => {
            this.webErrorService.handleAPIErrors(error, null, true, 'warn');
          });
        }
      }, (error: any) => {
        this.errorMessage = error.error.message;
        // this.webErrorService.handleAPIErrors(error, null, true, 'warn');
      });
    }
  }
}
